import Vue from 'vue'
import Router from 'vue-router'

function generateComponentFunction(path) {
  return resolve => require([`@/components${path}`], resolve)
}

const Home = generateComponentFunction('/home');
const Feedback = generateComponentFunction('/feedback');
const FeedbackSuccess = generateComponentFunction('/feedbackSuccess');
const HistoryList = generateComponentFunction('/history');
const HistoryDetail = generateComponentFunction('/detail');

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/mobile',
    name: 'Home',
    component: Home
  }, {
    path: '/mobile/feedback',
    name: 'Feedback',
    component: Feedback,
    meta: {
      keepAlive: true
    }
  }, {
    path: '/mobile/success',
    name: 'FeedbackSuccess',
    component: FeedbackSuccess
  }, {
    path: '/mobile/history',
    name: 'History',
    component: HistoryList
  }, {
    path: '/mobile/history/detail/:id',
    name: 'HistoryDetail',
    component: HistoryDetail
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js